import React, { useEffect, useState } from "react";
import { Alert, Button, Spinner, Table } from "react-bootstrap";
import { Plus } from "react-bootstrap-icons";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";

import AdminDashboard from "../AdminDashboard";
import MainSearch from "../../../Components/Body/MainSearch";
import PagePagination from "../../../Components/Body/PagePagination";
import { basicConfigMultipart } from "../../../constants";

const per_page_limit = 10;

const ListProducts = () => {
  const location = useLocation();

  const urlParams = new URLSearchParams(location.search);

  const search = urlParams.get("q");

  const page = urlParams.get("page") || 1;

  const [productsCount, setProductsCount] = useState(1);

  const [pages, setPages] = useState(1);

  const [loading, setLoading] = useState(true);

  const [showError, setShowError] = useState(false);

  const [productsList, setProductsList] = useState([]);

  useEffect(() => {
    const fetchProducts = async (search, per_page_limit) => {
      setShowError(false);
      setLoading(true);

      let formData = new FormData();

      // in order to fetch even hidden products on admin side
      formData.append("staff", true);

      formData.append("limit", per_page_limit);
      formData.append("page", page);

      if (search && search.trim().length > 0) {
        formData.append("q_search", search);
      }

      await axios
        .post(
          `${process.env.REACT_APP_API_URL}/filter/`,
          formData,
          basicConfigMultipart
        )
        .catch((_) => {
          setShowError(true);
        })
        .then((response) => {
          if (response && response.status === 200) {
            setProductsCount(response.data["count"]);
            setProductsList(response.data["products"]);
          } else {
            setShowError(true);
          }
        });

      setLoading(false);
    };

    fetchProducts(search, per_page_limit);
  }, [page, search]);

  useEffect(() => {
    setPages(Math.ceil(productsCount / per_page_limit));
  }, [productsCount]);

  return (
    <AdminDashboard>
      <>
        {showError && (
          <Alert
            variant="danger"
            onClose={() => {
              setShowError(false);
            }}
            dismissible
          >
            <Alert.Heading>Error fetching.</Alert.Heading>
          </Alert>
        )}
        {loading && <Spinner animation="grow" />}
        <div className="admin_content">
          <div className="admin_content_header">
            <h4>Select Product to change</h4>
            <Link to={"/admin/products/add/"}>
              <Button>
                <Plus size={25} /> Add New
              </Button>
            </Link>
          </div>
          {/* place a searchbox here */}
          <MainSearch />

          <div className="admin_content_content">
            <Table striped hover>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Visibility</th>
                  <th>Stock</th>
                  <th>Stock Status</th>
                </tr>
              </thead>
              <tbody>
                {productsList.map((prod, index) => {
                  return (
                    <tr key={index}>
                      <td>{prod.id}</td>
                      <td>
                        <Link to={`/admin/products/${prod.id}`}>
                          {prod.name}
                        </Link>
                      </td>
                      <td
                        style={{
                          color:
                            prod.catalog_visibility === "visible"
                              ? "green"
                              : "red",
                        }}
                      >
                        {prod.catalog_visibility}
                      </td>
                      <td>{prod.stock_quantity}</td>
                      <td
                        style={{
                          color:
                            prod.stock_status === "instock" ? "green" : "red",
                        }}
                      >
                        {prod.stock_status}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            {/* pagination here */}
            <PagePagination page={parseInt(page) || 1} pages={pages} />
          </div>
        </div>
      </>
    </AdminDashboard>
  );
};

export default ListProducts;
